// extracted by mini-css-extract-plugin
export var errorsContainer = "_uj-1";
export var link = "_uj-0";